import RefreshIcon from '@/assets/icons/Refresh';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { Search } from 'lucide-react';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

interface ProjectFilterProps {
  className?: string;
}

export const ProjectFilter: FC<ProjectFilterProps> = ({ className }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [taxNumber, setTaxNumber] = useState(searchParams.get('tax_number') || '');

  useEffect(() => {
    const currentTaxNumber = searchParams.get('tax_number') || '';
    if (currentTaxNumber !== taxNumber) {
      setTaxNumber(currentTaxNumber);
    }
  }, [searchParams]);

  const handleChange = (value: string) => {
    setTaxNumber(value);
  };

  const handleSearch = () => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      if (taxNumber.trim()) {
        newParams.set('tax_number', taxNumber.trim());
      } else {
        newParams.delete('tax_number');
      }
      // Reset to first page when filtering
      newParams.set('page', '1');
      return newParams;
    });
  };

  const handleClear = () => {
    setTaxNumber('');
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.delete('tax_number');
      newParams.set('page', '1');
      return newParams;
    });
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className={cn('border-b border-gray-200 py-2 pr-10 pl-6 bg-white', className)}>
      <div className="flex items-end justify-between gap-3">
        <div className="flex items-end gap-3">
          <div className="flex flex-col gap-1 min-w-[200px]">
            <Input
              value={taxNumber}
              onChange={(e) => handleChange(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder={t('farmer.stir') || ''}
              className="h-8"
            />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            type="button"
            onClick={handleSearch}
            variant="outline"
            className={cn(
              'p-[10px] active:translate-y-[1px] duration-200',
            )}
          >
            <Search className="stroke-cyan-default" />
          </Button>
          <Button
            type="button"
            onClick={handleClear}
            variant="outline"
            className="p-[10px] active:translate-y-[1px] duration-200"
          >
            <RefreshIcon />
          </Button>
        </div>
      </div>
    </div>
  );
};

